import React from "react";
import { cn } from "../utils";
import { CompactStatGrid, InlineStatCard } from "./compact-stat-card";

export function KpiStrip({ items, className, cols = "grid-cols-2 lg:grid-cols-4" }) {
  return (
    <CompactStatGrid cols={cols} className={className}>
      {items.map((item) => {
        const { key: itemKey, ...rest } = item;
        return <InlineStatCard key={itemKey || rest.label} {...rest} />;
      })}
    </CompactStatGrid>
  );
}

export function KpiStripRow({ children, className }) {
  return (
    <div className={cn("grid grid-cols-2 lg:grid-cols-4 gap-4", className)}>
      {children}
    </div>
  );
}
